








import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch, Emit } from "vue-property-decorator";
import { IHeader } from "@/store/models/staff/IHeader";
import { VcSubmissionDtoOfVcClaimUpdateRequestDto } from "@/asdcom/apiproxy/apiproxy.dto";
import MasterDetailsComponent from "@/components/vcponlineok/staff-user/master-details-component.vue";

interface ITableRow {
  id: number | undefined,
  submittedDate: string,
  status: string
}

@Component({components:{MasterDetailsComponent}})
export default class ClaimUpdateRequestListComponent extends BaseComponent {
  @Prop({
    default: () => {
      return null;
    }
  })
  viewModel?: VcSubmissionDtoOfVcClaimUpdateRequestDto[];

  headers: IHeader[] = [
    { text: "Submitted Date", value: "submittedDate", align: "center" },
    { text: "Status", value: "status", align: "center" }
  ];
  tableData: ITableRow[] = [];

  get getTableData() {
    if (this.viewModel !== undefined) {
      for (let item in this.viewModel) {
        let row = {} as ITableRow;
        row.id = this.viewModel[item].id;
        row.submittedDate = this.getDate(this.viewModel[item].submittedDate);
        row.status = this.getConstName("submissionStatus", this.viewModel[item].workItemStatus) as string;
        this.tableData.push(row);
      }
      
      return this.tableData;
    }
  }

}
